var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionContainer',[_c('section',{staticClass:"generic-text-panel rich-text-editor magazine-rich-text-editor",domProps:{"innerHTML":_vm._s(_vm.data.bodyText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }